<template>
    <div
        class="account-menu d-flex flex-wrap-reverse justify-end flex-row"
        :class="isMobile ? 'flex-column justify-start full-width' : ''"
    >
        <v-list density="compact" class="d-flex" :class="{'flex-column': isMobile}">
            <account-menu-custom-items />

            <v-list-item v-if="!authStore.isGuest" :to="{name: 'messages'}" @click="closeMenuAll">
                <v-list-item-title>
                    <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                        {{ $t('page_titles.messages_page_title') }}
                    </span>
                </v-list-item-title>
            </v-list-item>

            <v-list-item
                v-if="showOrders"
                data-cy="account-orders-button"
                :ripple="false"
                :to="{name: 'orders'}"
                @click="closeMenuAll"
            >
                <v-list-item-title class="d-flex align-center">
                    <v-icon class="me-1" @click.stop.prevent="onQuickSearchClick"> mdi-magnify </v-icon>
                    <v-fade-transition :hide-on-leave="true">
                        <div v-if="quickSearchOrdersShow" class="d-flex align-center">
                            <v-text-field
                                ref="quickSearch"
                                v-model="quickSearchOrdersText"
                                :placeholder="$t('quick_search')"
                                :loading="quickSearchOrdersLoading"
                                density="compact"
                                flat
                                variant="outlined"
                                hide-details
                                style="width: 128px"
                                class="text-caption"
                                @blur="quickSearchOrdersShow = false"
                                @keyup.enter="onQuickSearch"
                                @click.stop.prevent
                            />
                        </div>
                    </v-fade-transition>
                    <v-fade-transition :hide-on-leave="true">
                        <span
                            v-if="!quickSearchOrdersShow"
                            class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2"
                        >
                            {{ $t('orders') }}
                        </span>
                    </v-fade-transition>
                </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="showScheduler" :to="{name: 'scheduler'}">
                <v-list-item-title>
                    <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                        {{ $t('scheduler') }}
                    </span>
                </v-list-item-title>
            </v-list-item>

            <v-list-item
                v-if="showProducts"
                :to="{name: 'supplierProducts'}"
                data-cy="account-supplier-products-button"
                @click="closeMenuAll"
            >
                <v-list-item-title>
                    <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                        {{ $t('products') }}
                    </span>
                </v-list-item-title>
            </v-list-item>

            <v-list-item
                v-if="isShowReportsBtn"
                class="account-menu__item account-menu__item--reports"
                :to="{name: 'reports'}"
                data-cy="account-reports-button"
                @click="closeMenuAll"
            >
                <v-list-item-title>
                    <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                        {{ $t('reports') }}
                    </span>
                </v-list-item-title>
            </v-list-item>

            <v-list-item
                v-if="isSupplier"
                class="account-menu__item"
                :to="{name: 'reservationStatements'}"
                data-cy="account-supplier-invoices-button"
                @click="closeMenuAll"
            >
                <v-list-item-title>
                    <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                        {{ $t('reservation_statements') }}
                    </span>
                </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="isShowFinanceBtn" class="pa-0">
                <v-menu v-model="menuFinance" :close-on-content-click="false">
                    <template v-slot:activator="{props}">
                        <v-list-item v-bind="props">
                            <v-list-item-title>
                                <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                                    {{ $t('finance') }}
                                </span>
                                <v-icon end>mdi-menu-down</v-icon>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list density="compact">
                        <v-list-item
                            v-if="isB2B && $conf.public.account.paymentScheduler"
                            :to="{name: 'payments'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-cash </v-icon>
                            </template>
                            <v-list-item-title>{{ $t('payments') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="isB2B && !$conf.public.account.paymentScheduler"
                            :to="{name: 'invoices'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-receipt-text-outline </v-icon>
                            </template>
                            <v-list-item-title>{{ $t('invoices.invoice') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="isB2B" :to="{name: 'onlinePayments'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-credit-card-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('online_payments') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="isTO1" :to="{name: 'reservationStatements'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-receipt-text-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('reservation_statements') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item
                            v-if="isTourOperator || isAgency"
                            :to="{name: 'paymentsSettings'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-credit-card-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('payments_settings') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>
            <v-list-item v-if="hasBusinessIntelligenceAccess" class="pa-0">
                <v-menu v-model="menuBi" :close-on-content-click="false">
                    <template v-slot:activator="{props}">
                        <v-list-item v-bind="props">
                            <v-list-item-title>
                                <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                                    {{ $t('bi') }}
                                </span>
                                <v-icon end>mdi-menu-down</v-icon>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list density="compact">
                        <v-list-item v-if="isShowKpi" :to="{name: 'kpis'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-text-box-edit-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('KPI', 2) }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="isB2B" :to="{name: 'businessIntelligence'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-rocket</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('monitoring') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>

            <v-list-item v-if="showCompany" class="pa-0">
                <v-menu v-model="menuCompany" :close-on-content-click="false">
                    <template v-slot:activator="{props}">
                        <v-list-item class="account-menu__item--my-company" v-bind="props">
                            <v-list-item-title>
                                <span class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2">
                                    {{ $t('my_company') }}
                                </span>
                                <v-icon end>mdi-menu-down</v-icon>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list density="compact">
                        <v-list-item v-if="isB2B" :to="{name: 'company-profile'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-domain</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('my_company') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="isB2B" :to="{name: 'companyPersons'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-multiple</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('users') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item v-if="isB2B && !isCorporate" :to="{name: 'companyClients'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-human-male-female</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('private_clients') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="
                                isB2B &&
                                (isAgency || isTourOperator) &&
                                !['to1l.agent'].includes(authStore.person.role) &&
                                $conf.public.account.showCorporateClients
                            "
                            :to="{name: 'companyCorporateClients'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-tie</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('corporate_clients') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="
                                isB2B &&
                                isTourOperator &&
                                !['to1l.agent'].includes(authStore.person.role) &&
                                $conf.public.account.showAgencies
                            "
                            :to="{name: 'companyAgencies'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-brightness-auto</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('agencies_and_distributors') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="showSuppliers" :to="{name: 'companySuppliers'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-multiple-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('suppliers', 2) }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item
                            v-if="hasAccessToSalesSettings"
                            :to="{name: 'salesSettings'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-sale-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('sales_settings') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item
                            v-if="runtimeStore.CRMSettings?.extendedCrm"
                            :to="{name: 'registrationRequests'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-plus</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('leads_registration_requests') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="isTO1 && $conf.public.account.communicationsPage"
                            :to="{name: 'communications'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-group-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('communications_and_notes') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="isShowCampaigns" :to="{name: 'campaigns'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-ampersand </v-icon>
                            </template>
                            <v-list-item-title>{{ $t('campaigns') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="showDashboards" :to="{name: 'dashboards'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-chart-bar</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('dashboards') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="isTO1 && $conf.public.inboundEmails"
                            :to="{name: 'inboundEmails'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-email-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('inbound_emails') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="isShowReviewsAndFeedback" :to="{name: 'feedback'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-message-star-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('reviews_and_feedback') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>

            <account-menu-append-items />
        </v-list>

        <v-list density="compact" class="d-flex" :class="{'flex-column': isMobile}">
            <v-list-item v-if="!person && $conf.public.tripAssistant">
                <v-list-item-title class="cursor-pointer" @click="tripAssistant = true">
                    <span class="account-menu__item-text font-weight-medium text-subtitle-2">
                        {{ $t('trip_assistant') }}
                    </span>
                    <TripAssistantModal v-model="tripAssistant" />
                </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="showFavorites && !isTO1" class="account-menu__item--favorites" :to="{name: 'favorites'}">
                <v-list-item-title>
                    <span class="account-menu__item-text font-weight-medium text-subtitle-2">
                        {{ $t('favorites') }}
                    </span>
                </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="hasEmailTemplatesAccess || hasCMSAccess" class="pa-0">
                <v-menu v-model="menuSettings" :close-on-content-click="false">
                    <template v-slot:activator="{props}">
                        <v-list-item v-bind="props" data-cy="login-menu-button">
                            <v-list-item-title>
                                <v-icon size="small" start>mdi-cog</v-icon>
                                <v-icon>mdi-menu-down</v-icon>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <!-- eslint-disable vue/no-v-model-argument -->
                    <v-list
                        v-model:selected="adminMenu"
                        density="compact"
                        open-strategy="multiple"
                        active-class=""
                        @update:selected="changeAdminMenu"
                    >
                        <v-list-item
                            v-if="hasEmailTemplatesAccess"
                            :to="{name: 'emailTemplates'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-file-document-edit-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('admin.templates') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="hasCMSAccess" @click="cmsLogin">
                            <template v-slot:prepend>
                                <v-icon start>mdi-rocket</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('admin.cms') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="$conf.public.admin.showTranslationKeys" value="showTranslationKeys">
                            <template v-slot:prepend="{isActive}">
                                <v-list-item-action start>
                                    <v-checkbox-btn :model-value="isActive" style="margin-left: 6px" class="px-0" />
                                </v-list-item-action>
                            </template>
                            <v-list-item-title class="ms-3">{{ $t('admin.translation_keys') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item :to="{name: 'locations'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-earth</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('locations') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="{name: 'venues'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-stadium-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('venues') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="hasAccessToVehicleTypes" :to="{name: 'vehicleTypes'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-car</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('vehicle_types') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item
                            v-if="isTourOperator || isAgency"
                            :to="{name: 'exchangeRates'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-cash</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('exchange_rates') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item :to="{name: 'allPersons'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-account-multiple</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('all_users') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="{name: 'allCompanies'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-domain</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('all_companies') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>

            <v-list-item v-if="isTO1" class="pa-0">
                <v-menu v-model="menuInfo" :close-on-content-click="false">
                    <template v-slot:activator="{props}">
                        <v-list-item v-bind="props" data-cy="info-menu-button">
                            <v-list-item-title>
                                <v-icon size="small" start>mdi-help-circle-outline</v-icon>
                                <v-icon>mdi-menu-down</v-icon>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <!-- eslint-disable vue/no-v-model-argument -->
                    <v-list
                        v-model:selected="adminMenu"
                        density="compact"
                        open-strategy="multiple"
                        active-class=""
                        @update:selected="changeAdminMenu"
                    >
                        <v-list-item
                            v-if="$conf.public.account?.guideLinks?.releaseNotes"
                            :href="$conf.public.account.guideLinks.releaseNotes"
                            target="_blank"
                            @click="closeMenuAll"
                        >
                            <v-list-item-title>{{ $t('release_presentations') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="$conf.public.account?.guideLinks?.trainingVideos"
                            :href="$conf.public.account.guideLinks.trainingVideos"
                            target="_blank"
                            @click="closeMenuAll"
                        >
                            <v-list-item-title>{{ $t('training_videos') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="$conf.public.account?.guideLinks?.apiDocumentation"
                            :href="$conf.public.account.guideLinks.apiDocumentation"
                            target="_blank"
                            @click="closeMenuAll"
                        >
                            <v-list-item-title>{{ $t('api_documentation') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="$conf.public.account?.guideLinks?.faq"
                            :href="$conf.public.account.guideLinks.faq"
                            target="_blank"
                            @click="closeMenuAll"
                        >
                            <v-list-item-title>{{ $t('faq') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="reportIssue?.url" @click="showReportIssueModal">
                            <v-list-item-title>{{ $t('report_issue') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>

            <language-switcher />

            <currency-switcher v-if="showCurrencySwitcher" />

            <v-list-item v-if="!person" class="pa-0">
                <v-list-item-title class="pa-0">
                    <v-btn
                        variant="text"
                        color="inherit"
                        data-cy="login-modal-button"
                        class="py-2 font-weight-medium text-subtitle-2"
                        @click="goToB2BAuth"
                    >
                        {{ $t('log_in') }}
                    </v-btn>
                </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="person" class="pa-0 account-menu__item account-menu__item--person">
                <v-menu v-model="menu" :close-on-content-click="false">
                    <template v-slot:activator="{props}">
                        <v-list-item v-bind="props" data-cy="login-menu-button">
                            <v-list-item-title>
                                <person-label
                                    :person="person"
                                    class="account-menu__item-text font-weight-medium text-uppercase text-subtitle-2"
                                />
                                <v-icon end>mdi-menu-down</v-icon>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list density="compact">
                        <v-list-item
                            :to="
                                isB2B
                                    ? {
                                          name: 'companyPerson',
                                          params: {id: person.personId, companyId: person.companyId},
                                      }
                                    : {name: 'user-settings'}
                            "
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-account</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('account') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="showFavorites && isTO1" :to="{name: 'favorites'}" @click="closeMenuAll">
                            <template v-slot:prepend>
                                <v-icon start>mdi-cards-heart-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('favorites') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="isShowCommunicationsCalendarBtn"
                            :to="{name: 'communicationsCalendar'}"
                            @click="closeMenuAll"
                        >
                            <template v-slot:prepend>
                                <v-icon start>mdi-calendar-multiselect-outline</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('my_calendar') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="logout">
                            <template v-slot:prepend>
                                <v-icon start>mdi-exit-to-app</v-icon>
                            </template>
                            <v-list-item-title>{{ $t('log_out') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>
        </v-list>

        <ReportIssueModal v-model="reportIssueModal" @select="openReportIssue" />
    </div>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import {AUTH_EVENT, EventBus, SHOW_AUTH_MODAL} from '@/utils/event-bus'
    import PersonLabel from '~src/components/account/snippets/personLabel.src'
    import AccountMenuCustomItems from '~src/components/account/snippets/accountMenuCustomItems.src'
    import {AuthInfoMixin} from '~src/mixins/authInfoMixin.src'
    import {PersonRole} from '~/utils/types/types'
    import AccountMenuAppendItems from '~src/components/account/snippets/AccountMenuAppendItems.vue'
    import TripAssistantModal from '~/components/account/modals/tripAssistant/TripAssistantModal.vue'
    import CurrencySwitcher from '~/components/CurrencySwitcher.vue'
    import LanguageSwitcher from '~/components/LanguageSwitcher.vue'
    import {getRecentJsErrors} from '~/utils/recent-js-errors'

    const REPORT_ISSUE_SENSITIVE_PARAMS = ['token', 'apiKey']

    @Component({
        components: {
            LanguageSwitcher,
            CurrencySwitcher,
            AccountMenuAppendItems,
            TripAssistantModal,
            AccountMenuCustomItems,
            PersonLabel,
        },
    })
    export class AccountMenu extends mixins(AuthInfoMixin) {
        menu = false
        menuCompany = false
        menuSettings = false
        menuInfo = false
        menuFinance = false
        forgotPassword = false
        quickSearchOrdersText = ''
        quickSearchOrdersLoading = false
        quickSearchOrdersShow = false
        quickSearch = null
        menuBi = false
        tripAssistant = false
        reportIssueInfo = null
        reportIssueModal = false
        commitHash = null

        async logout() {
            this.closeMenuAll()
            const isSupplier = authStore.isSupplier
            const isGuide = authStore.isGuide
            const isDriver = authStore.isDriver
            const personRole = authStore.personRole

            if (this.$route.name !== 'home' && !isSupplier && !isGuide && !isDriver && personRole !== 'dispatcher') {
                await this.$router.push({name: 'home'})
            }

            authStore.logOut()

            if (this.$conf.public.onlyRegistered || isSupplier || isGuide || isDriver || personRole === 'dispatcher') {
                await this.$router.push({
                    name: this.$conf.public.onlyRegistered === 'client' ? 'authorization' : 'b2b-auth',
                })
            } else {
                await authStore.auth()
            }
            this.$toast.success(this.$t('messages.success.logout'))
        }

        goToRegister() {
            this.closeMenuAll()
            this.$router.push({name: 'register'})
        }

        onForgotPassword() {
            this.closeMenuAll()
            this.forgotPassword = false
        }

        mounted() {
            EventBus.$on(AUTH_EVENT, this.onAuth)
            this.loadReportIssueInfo()
            this.loadCommitHash()
        }

        beforeUnmount() {
            EventBus.$off(AUTH_EVENT, this.onAuth)
        }

        showAuthModal() {
            EventBus.$emit(SHOW_AUTH_MODAL)
        }

        onAuth() {
            if (this.menu) {
                this.$toast.success(this.$t('messages.success.authorized'))
            }
            this.closeMenuAll()
            this.$emit('auth')
            this.loadReportIssueInfo()
        }

        async loadReportIssueInfo() {
            if (this.reportIssueInfo || !this.isTO1) {
                return
            }
            try {
                this.reportIssueInfo = await this.$api.reportIssueInfo.get()
            } catch (e) {
                console.error(e)
            }
        }

        async loadCommitHash() {
            if (this.commitHash) {
                return
            }
            try {
                const base = this.$conf.public.routerBase || '/'
                const response = await fetch(`${base.endsWith('/') ? base : `${base}/`}build-info.txt`)
                const hash = response.ok ? (await response.text()).trim() : ''
                // A missing file answers with the SPA fallback page — accept only a hash
                if (/^[0-9a-f]{7,40}$/i.test(hash)) {
                    this.commitHash = hash
                }
            } catch (e) {
                console.error(e)
            }
        }

        showReportIssueModal() {
            this.reportIssueModal = true
            this.closeMenuAll()
        }

        openReportIssue(requestType: 'systemError' | 'question' | 'changeRequest') {
            if (!this.reportIssueInfo) {
                this.loadReportIssueInfo()
            }
            if (!this.commitHash) {
                this.loadCommitHash()
            }
            const {url: reportIssueUrl, requestTypes, fields} = this.reportIssue
            const url = new URL(reportIssueUrl + requestTypes[requestType])
            const clientUrl = new URL(window.location.href)
            REPORT_ISSUE_SENSITIVE_PARAMS.forEach(param => clientUrl.searchParams.delete(param))
            url.searchParams.set(fields.clientUrl, clientUrl.toString())
            const username = authStore.person?.login || authStore.person?.email
            if (username) {
                url.searchParams.set(fields.clientUsername, username)
            }
            const email = authStore.person?.email
            if (email && fields.email) {
                url.searchParams.set(fields.email, email)
            }
            const version = this.reportIssueInfo?.version || this.$conf.public.version
            if (version) {
                url.searchParams.set(fields.version, version)
            }
            if (this.reportIssueInfo?.solution) {
                url.searchParams.set(fields.solution, this.reportIssueInfo.solution)
            }
            if (this.reportIssueInfo?.installationType) {
                url.searchParams.set(fields.installationType, this.reportIssueInfo.installationType)
            }
            if (this.reportIssueInfo?.supportOrganizationId && fields.supportOrganizationId) {
                url.searchParams.set(fields.supportOrganizationId, this.reportIssueInfo.supportOrganizationId)
            }
            const role = authStore.person?.role
            if (role && fields.role) {
                url.searchParams.set(fields.role, role)
            }
            // Front-end exceptions are relevant for system errors only and would bloat the other links
            if (requestType === 'systemError' && fields.recentJsErrors) {
                const recentJsErrors = getRecentJsErrors()
                if (recentJsErrors.length) {
                    url.searchParams.set(fields.recentJsErrors, JSON.stringify(recentJsErrors))
                }
            }
            if (this.commitHash && fields.commitHash) {
                url.searchParams.set(fields.commitHash, this.commitHash)
            }
            window.open(url.toString(), '_blank', 'noopener')
            this.closeMenuAll()
        }

        get reportIssue() {
            return this.$conf.public.account?.reportIssue
        }

        async cmsLogin() {
            try {
                const {token, user} = await this.$api.cmsAuth.post()
                const form = document.createElement('form')
                form.method = 'POST'
                form.target = '_blank'
                form.action = `${this.$conf.public.routerBase || '/'}cms/admin/auth/auto`
                const jwtField = document.createElement('input')
                jwtField.type = 'hidden'
                jwtField.name = 'jwt'
                jwtField.value = token
                form.appendChild(jwtField)
                const userField = document.createElement('input')
                userField.type = 'hidden'
                userField.name = 'user'
                userField.value = JSON.stringify(user)
                form.appendChild(userField)
                document.body.appendChild(form)
                form.submit()
                document.body.removeChild(form)
                this.closeMenuAll()
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }

        closeMenuAll() {
            this.menu = false
            this.menuCompany = false
            this.menuFinance = false
            this.menuSettings = false
            this.menuBi = false
        }

        goToB2BAuth() {
            this.closeMenuAll()
            this.$router.push({name: 'home'})
        }

        async onQuickSearchClick() {
            this.quickSearchOrdersShow = true
            await this.$nextTick()
            this.$refs.quickSearch.focus()
        }

        async onQuickSearch() {
            this.quickSearchOrdersLoading = true

            try {
                const orders = (
                    await this.$api.orders.get({
                        orderType: authStore.orderType,
                        responseType: 'SHORT',
                        orderId: this.quickSearchOrdersText,
                    })
                ).orders

                if (orders.length) {
                    await this.$router
                        .push({name: 'order-details', params: {id: this.quickSearchOrdersText}})
                        .catch(() => {})
                } else {
                    this.$toast.error(this.$t('quick_search_error'), {
                        y: 'bottom',
                    })
                }
            } catch (e) {
                this.$toast.error(this.$t('quick_search_error'), {
                    y: 'bottom',
                })
            } finally {
                this.quickSearchOrdersLoading = false
            }
        }

        changeAdminMenu(adminMenu) {
            if (adminMenu.includes('showTranslationKeys')) {
                this.$i18n.fallbackLocale = 'no-such-locale'
                this.$i18n.setLocale('no-such-locale')
            } else {
                this.$i18n.fallbackLocale = 'en'
                this.$i18n.setLocale(this.$conf.public.locales[0])
            }
        }

        get adminMenu() {
            return this.$i18n.locale === 'no-such-locale' ? ['showTranslationKeys'] : []
        }

        get showDashboards() {
            return ['director', 'supervisor', 'support'].includes(this.personRole)
        }

        get showSuppliers() {
            return this.isTO1 && ['director', 'supervisor', 'support'].includes(this.personRole)
        }

        //TODO: need to rename and add isB2B
        get isB2B() {
            return authStore.hasCorporateAccess
        }

        get isCorporate() {
            return authStore.isCorporate
        }

        get isSupplier() {
            return authStore.isSupplier
        }

        get gpLoginLink() {
            return this.$conf.public.gpLoginLink
        }

        get b2bLogin() {
            return this.$conf.public.b2bLogin
        }

        get hasCMSAccess() {
            return this.isB2B && ['to1l.supervisor', 'to1l.director', 'to1l.support'].includes(authStore.person.role)
        }

        get hasEmailTemplatesAccess() {
            return this.isB2B && ['to1l.supervisor', 'to1l.director', 'to1l.support'].includes(authStore.person.role)
        }

        get hasBusinessIntelligenceAccess() {
            return (
                this.$conf.public.account.hasBusinessIntelligenceAccess &&
                this.isB2B &&
                ['supervisor', 'director', 'support'].includes(this.personRole)
            )
        }

        get hasAccessToVehicleTypes() {
            return this.isTO1 && ['to1l.supervisor', 'to1l.director', 'to1l.support'].includes(authStore.person.role)
        }

        get hasAccessToSalesSettings() {
            return (
                (this.isTO1 &&
                    !['to1l.content.manager', 'to1l.agent', 'to1l.flight.manager'].includes(authStore.person.role)) ||
                authStore.isTO2
            )
        }

        get isTourOperator() {
            return authStore.isTourOperator
        }

        get isTO1() {
            return authStore.isTO1
        }

        get isAgency() {
            return authStore.isAgency
        }

        get person() {
            return authStore.person
        }

        get personRole() {
            return authStore.personRole
        }

        get showFavorites() {
            return (
                (this.activeProducts.includes('hotels') || this.activeProducts.includes('activities')) &&
                this.personRole !== 'dispatcher' &&
                !this.isSupplier &&
                !this.isDriverOrGuide
            )
        }

        get showScheduler() {
            const paymentScheduler = this.$conf.public.driverScheduler

            return (
                paymentScheduler &&
                ((this.isTO1 && ['supervisor', 'director', 'dispatcher', 'support'].includes(this.personRole)) ||
                    this.isDriverOrGuide)
            )
        }

        get isShowReviewsAndFeedback() {
            return (
                this.isTO1 &&
                this.$conf.public.account.reviewsAndFeedback &&
                ['supervisor', 'director', 'support'].includes(this.personRole)
            )
        }

        get isShowKpi() {
            const isCRMCampaignOption = runtimeStore.getCRMOption('asp.option.show.kpi')
            return this.isTO1 && isCRMCampaignOption
        }

        get isShowCampaigns(): boolean {
            const isCRMCampaignOption = runtimeStore.getCRMOption('asp.option.marketing.campaigns')
            return (
                this.isTO1 &&
                [PersonRole.Supervisor, PersonRole.Director, PersonRole.Support].includes(this.personRole) &&
                isCRMCampaignOption
            )
        }

        get isShowReportsBtn() {
            return (
                this.person &&
                (this.isB2B || this.isTourOperator) &&
                this.personRole !== 'dispatcher' &&
                !this.isSupplier &&
                (this.$conf.public.showReportsTab || (this.isTO1 && this.$conf.public.showReportsTabTO1)) &&
                !this.isDriverOrGuide
            )
        }

        get isShowFinanceBtn() {
            return (
                this.isTO1 && ['supervisor', 'director', 'support'].includes(this.personRole) && !this.isDriverOrGuide
            )
        }

        get isShowCommunicationsCalendarBtn() {
            return this.person && this.isTO1 && this.$conf.public.account.showCommunications && !this.isDriverOrGuide
        }

        get isGuide() {
            return authStore.isGuide
        }

        get isDriver() {
            return authStore.isDriver
        }

        get isDriverOrGuide() {
            return this.isDriver || this.isGuide
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }

        get showOrders() {
            return this.person && !this.isDriverOrGuide
        }

        get showProducts() {
            return (
                this.person &&
                (this.isSupplier ||
                    (this.isTO1 &&
                        ['supervisor', 'director', 'manager', 'support', 'content.manager'].includes(
                            this.personRole
                        ))) &&
                !this.isDriverOrGuide &&
                (this.$conf.public.account.productsManagement ||
                    (this.$conf.public.account.productsManagementForSuppliersHotelsRAOnly && this.isSupplier))
            )
        }

        get showCompany() {
            return (
                this.person &&
                (this.isB2B || this.isTourOperator) &&
                this.personRole !== 'dispatcher' &&
                !this.isSupplier &&
                !this.isDriverOrGuide &&
                !authStore.isAccountant &&
                !['to1l.content.manager', 'to1l.flight.manager'].includes(authStore.person.role)
            )
        }

        get showCurrencySwitcher() {
            return false // Currency selector disabled for ZSH tenant
        }
    }

    export default AccountMenu
</script>

<style lang="scss" scoped>
    :deep(div) {
        .v-list-item:hover::before,
        .v-list-item:active::before,
        .v-list-item:focus::before,
        .v-list-item--active::before {
            opacity: 0 !important;
        }

        .v-list-item--active .v-btn::before {
            opacity: 0.04 !important;
        }

        .v-list-item__icon {
            margin-right: 12px !important;
        }
    }
</style>
